import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ConfirmDialog from "../components/ConfirmDialog";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { getErrorString } from "../display/ErrorStrings";
import { BUILD_NUMBER } from "../components/Constants";

class LoginSupportForm extends Component {
  constructor(props) {
    super(props);
    const root = document.getElementById("root");
    const loginTitle = root.getAttribute("login_page_title");
    const loginToolbarColor = root.getAttribute("login_page_toolbar_color");

    this.state = {
      userName: "",
      userPassword: "",
      userRealm: "",
      companyUserName: "",
      newPassword: "",
      confirmNewPassword: "",
      activationKey: "",
      actionType: 0,
      errorString: "",
      submitDisabled: false,
      loginTitle: loginTitle + " (support console)",
      loginToolbarColor: loginToolbarColor,
      confirmLogoutSession: false,
    };
    this.handleUserNameChange = this.handleUserNameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleRealmChange = this.handleRealmChange.bind(this);
    this.handleCompanyUserNameChange = this.handleCompanyUserNameChange.bind(
      this
    );
    this.handleNewPasswordChange = this.handleNewPasswordChange.bind(this);
    this.handleConfirmNewPasswordChange = this.handleConfirmNewPasswordChange.bind(
      this
    );
    this.handleActivationKeyChange = this.handleActivationKeyChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleKeyPress = (e) => {
    if (e.key === "Enter" && !this.state.submitDisabled) {
      e.preventDefault();
      e.stopPropagation();
      this.handleFormSubmit(e);
    }
  };
  handleUserNameChange(e) {
    this.setState({ userName: e.target.value });
    this.setState({ errorString: "" });
  }
  handlePasswordChange(e) {
    this.setState({ userPassword: e.target.value });
    this.setState({ errorString: "" });
  }
  handleRealmChange(e) {
    this.setState({ userRealm: e.target.value });
    this.setState({ errorString: "" });
  }
  handleCompanyUserNameChange(e) {
    this.setState({ companyUserName: e.target.value });
    this.setState({ errorString: "" });
  }
  handleNewPasswordChange(e) {
    this.setState({ newPassword: e.target.value });
    this.setState({ errorString: "" });
  }
  handleConfirmNewPasswordChange(e) {
    this.setState({ confirmNewPassword: e.target.value });
    this.setState({ errorString: "" });
  }
  handleActivationKeyChange(e) {
    this.setState({ activationKey: e.target.value });
    this.setState({ errorString: "" });
  }
  handleLogout(e, action) {
    e.preventDefault();
    this.setState({ confirmLogoutSession: false });
    if (action === 1) {
      fetch("on_logout_force", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName: this.state.userName,
          realm: this.state.userRealm,
          r: new Date().getTime(),
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            throw Error(res.status + " (" + res.statusText + ")");
          }
          return res;
        })
        .then((res) => res.text())
        .then((text) => {
          if (window.sco_return_url) {
            window.location.href = window.sco_return_url;
          } else {
            this.props.history.push("/");
          }
        })
        .catch((error) => {
          this.setState({
            errorString:
              getErrorString(
                "general.server.status.error",
                "The server responded with a status of "
              ) + error.message,
          });
        });
      this.setState({
        errorString: getErrorString(
          "user.login.retry",
          "Your existing session was disconnected. Please login."
        ),
      });
    }
  }

  handleFormSubmit(e) {
    e.preventDefault();
    if (this.state.actionType === 0) {
      if (this.state.userName == null || this.state.userName === "") {
        this.setState({
          errorString: getErrorString(
            "login.username.error",
            "User Name is required"
          ),
        });
        return;
      }
      if (this.state.userPassword == null || this.state.userPassword === "") {
        this.setState({
          errorString: getErrorString(
            "login.password.error",
            "Password is required"
          ),
        });
        return;
      }
      if (this.state.userRealm == null || this.state.userRealm === "") {
        this.setState({
          errorString: getErrorString("login.realm.error", "Realm is required"),
        });
        return;
      }
      if (
        this.state.companyUserName == null ||
        this.state.companyUserName === ""
      ) {
        this.setState({
          errorString: getErrorString(
            "login.companyusername.error",
            "Company User Name is required"
          ),
        });
        return;
      }
    } else if (this.state.actionType === 1) {
      if (this.state.userPassword == null || this.state.userPassword === "") {
        this.setState({
          errorString: getErrorString(
            "login.oldpassword.error",
            "Old Password is required."
          ),
        });
        return;
      }
      if (this.state.newPassword == null || this.state.newPassword === "") {
        this.setState({
          errorString: getErrorString(
            "login.newpassword.error",
            "New Password is required."
          ),
        });
        return;
      }
      if (
        this.state.confirmNewPassword == null ||
        this.state.confirmNewPassword === ""
      ) {
        this.setState({
          errorString: getErrorString(
            "login.confirmpassword.error",
            "Confirm Password is required."
          ),
        });
        return;
      }
      if (this.state.newPassword.length < 8) {
        this.setState({
          errorString: getErrorString(
            "login.passwordLength.error",
            "New Password must be at least 8 characters."
          ),
        });
        return;
      }
      if (this.state.confirmNewPassword !== this.state.newPassword) {
        this.setState({
          errorString: getErrorString(
            "login.passwordNotMatch.error",
            "New and Confirm Passwords do not match."
          ),
        });
        return;
      }
    } else if (this.state.actionType === 2) {
      if (this.state.activationKey == null || this.state.activationKey === "") {
        this.setState({
          errorString: getErrorString(
            "login.activationKey.error",
            "Activation Key is required."
          ),
        });
        return;
      }
    }
    this.setState({ confirmLogoutSession: false });
    this.setState({ errorString: "" });
    this.setState({ submitDisabled: true });
    fetch("on_login", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        actionType: this.state.actionType,
        userName: this.state.userName,
        password: this.state.userPassword,
        realm: this.state.userRealm,
        companyUserName: this.state.companyUserName,
        support_login: "yes",
        newPassword: this.state.newPassword,
        activationKey: this.state.activationKey,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.error === true) {
          if (
            getErrorString(
              "user.login.access.denied",
              "Access denied! This user is currently logged in."
            ) === reply.errorString
          ) {
            this.setState({ confirmLogoutSession: true });
            this.setState({ errorString: reply.errorString });
            this.setState({ submitDisabled: false });
          } else {
            this.setState({ errorString: reply.errorString });
            this.setState({ submitDisabled: false });
          }
        } else if (reply.warning === true) {
          this.setState({ submitDisabled: false });
          if ("change_password" === reply.warningString) {
            this.setState({
              errorString:
                "User required to change the password. Please change the password in the bank application.",
            });
            this.setState({ submitDisabled: false });
          } else if ("activate" === reply.warningString) {
            this.setState({
              errorString:
                "User Account not active. Please activate the user in the bank application.",
            });
            this.setState({ submitDisabled: false });
          } else {
            this.setState({
              errorString:
                "Unexpected service reply. Please contact your system administrator",
            });
            this.setState({ submitDisabled: false });
          }
        } else {
          this.props.history.push({
            pathname: "/enter",
            state: {
              secureToken: reply.secureToken,
              lastLogin: reply.lastLogin,
              isReadOnly: true,
            },
          });
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ submitDisabled: false });
      });
  }

  render() {
    return (
      <div>
        {this.state.confirmLogoutSession && (
          <ConfirmDialog
            title="Another user session is active."
            text="Are you sure you want to disconnect the existing user session?"
            onCloseConfirm={this.handleLogout}
          />
        )}
        <AppBar
          position="static"
          style={{ background: this.state.loginToolbarColor }}
        >
          <Toolbar>
            <img
              src="login_logo.png"
              alt="Bank logo"
              style={{ maxWidth: "140px", maxHeight: "60px" }}
            />
            {/* <Typography variant="h6" color={"inherit"} >
            {APPNAME}   
          </Typography> */}
          </Toolbar>
        </AppBar>

        <Dialog open fullScreen={this.props.fullScreen}>
          <DialogTitle>
            {this.state.actionType === 0
              ? this.state.loginTitle
              : this.state.actionType === 1
              ? "Change Your Password"
              : "Activate Your Account"}
          </DialogTitle>
          <div
            onKeyPress={(e: KeyboardEvent<HTMLDivElement>) =>
              this.handleKeyPress(e)
            }
          >
            {this.state.actionType === 0 && (
              <DialogContent>
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Bank User Name"
                  type="text"
                  autoComplete="off"
                  fullWidth
                  required
                  onChange={this.handleUserNameChange}
                />
                <TextField
                  margin="dense"
                  id="password"
                  label="Bank User Password"
                  type="password"
                  autoComplete="new-password"
                  fullWidth
                  required
                  onChange={this.handlePasswordChange}
                />
                <TextField
                  margin="dense"
                  id="realm"
                  label="Company"
                  type="text"
                  autoComplete="off"
                  fullWidth
                  required
                  onChange={this.handleRealmChange}
                />
                <TextField
                  margin="dense"
                  id="realm"
                  label="Company User Name"
                  type="text"
                  autoComplete="off"
                  fullWidth
                  required
                  onChange={this.handleCompanyUserNameChange}
                />
              </DialogContent>
            )}
          </div>
          <DialogActions>
            <Button
              variant="outlined"
              onClick={this.handleFormSubmit}
              color="primary"
              disabled={this.state.submitDisabled}
            >
              Submit
            </Button>
          </DialogActions>
          {this.state.errorString.length > 0 && (
            <Typography
              style={{ paddingLeft: 10 }}
              color="error"
              variant="body1"
            >
              {" "}
              {getErrorString("general.error", "ERROR: ") +
                this.state.errorString}
            </Typography>
          )}
          {this.state.actionType === 0 && (
            <Typography
              style={{ fontSize: 10, paddingLeft: 10 }}
              color="primary"
              variant="body1"
            >
              {" "}
              Please login with your bank user credentials to impersonate a
              company user.
              <br />
              Support user rights are required.
            </Typography>
          )}
          {this.state.actionType === 1 && (
            <Typography
              style={{ fontSize: 10, paddingLeft: 10 }}
              color="primary"
              variant="body1"
            >
              {" "}
              You are required to change your password at this time.
              <br />
              New password must be minimum 8 characters <br />
              with at least one digit, one letter and one special character.
            </Typography>
          )}
          {this.state.actionType === 2 && (
            <Typography
              style={{ fontSize: 10, paddingLeft: 10 }}
              color="primary"
              variant="body1"
            >
              {" "}
              Please contact us if you do not have an activation key.
            </Typography>
          )}
          <br></br>
          <Typography
            style={{ fontSize: 8, paddingLeft: 10 }}
            color="primary"
            variant="body1"
          >
            {BUILD_NUMBER}
          </Typography>
        </Dialog>
      </div>
    );
  }
}

export default LoginSupportForm;
